import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpConstants } from '../constants/http-constants';
import { IpDetailsResponse } from '../models/ip-details-response.model';
import { Observable } from 'rxjs';
import { AmoRequest } from '../../business-account/models/amo-request.model';
import { StorageData } from '../models/storage.model';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MerchantService {
  private _ipDetails: IpDetailsResponse;

  constructor(private http: HttpClient) {}

  get ipDetails() {
    return this._ipDetails;
  }

  public getIpDetails(): Observable<IpDetailsResponse> {
    const headers = new HttpHeaders({
      'Content-Type': HttpConstants.APPLICATION_JSON_HEADER
    });

    return this.http
      .get<IpDetailsResponse>(HttpConstants.API_IP_DETAILS, {
        headers: headers
      })
      .pipe(tap((ipDetails) => (this._ipDetails = ipDetails)));
  }

  public onboard(amoRequest: AmoRequest, sessionId: any): Observable<void> {
    return this.http.post<void>(HttpConstants.API_ONBOARD(sessionId), amoRequest);
  }

  public submit(sessionId: any): Observable<void> {
    const headers = new HttpHeaders({
      'Content-Type': HttpConstants.APPLICATION_JSON_HEADER
    });

    return this.http.post<void>(HttpConstants.API_MERCHANT_DOCUMENTS_SUBMIT(sessionId), '', {
      headers: headers
    });
  }

  public save(amoRequest: AmoRequest, sessionId: any): Observable<void> {
    return this.http.post<void>(HttpConstants.API_SAVE(sessionId), amoRequest);
  }

  public getStorage(key: string, sessionId: any): Observable<any> {
    let params = new HttpParams();
    params = params.append('key', key);
    params = params.append('type', 'DATA');

    return this.http.get<any>(HttpConstants.API_SESSIONS(sessionId), { params: params });
  }

  public postStorage(storageData: StorageData, sessionId: any): Observable<void> {
    return this.http.post<void>(HttpConstants.API_SESSIONS(sessionId), storageData);
  }
}
